/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Modal } from "react-bootstrap";
import BaseCom from "./BaseCom";
import FormInput from "./FormInput";
import { qreq } from "../shared/qrequest";
import Globals from "../shared/Globals";
import { v4 as uuidv4 } from 'uuid';
import L from "./Lang";

export const HTMLEditorFieldGlobal = {
    init(showFunction, hideFunction) {
        this.show = showFunction;
        this.hide = hideFunction;
    },

    show(selInfo, onSave) {
        //overriden on init
    },

    hide() {
        //overriden on init
    }
};

export default class HTMLEditorField extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            info: {},
            pages: []
        };
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
        this.submit = this.submit.bind(this);
        HTMLEditorFieldGlobal.init(this.show, this.hide);
    }

    componentDidMount() {
    }

    show(selInfo, onSave) {
        this.setState({ info: { ...selInfo }, showModal: true, onSave: onSave });
    }

    hide() {
        this.setState({ info: {}, showModal: false, onSave: null });
    }

    submit(e) {
        e.preventDefault();
        var info = { ...this.state.info };

        if (!info.fieldIdent)
            info.fieldIdent = uuidv4();

        this.state.onSave(info);
        this.hide();
    }

    render() {
        return <Modal show={this.state.showModal} onHide={() => this.setState({ showModal: false })}>
            <Modal.Header closeButton>
                <Modal.Title><L>Insert Field</L></Modal.Title>
            </Modal.Header>
            <form onSubmit={this.submit}>
                <Modal.Body>
                    <FormInput model={this.state.info} name="fieldName" label="Field Name" type="text" required />
                    <FormInput model={this.state.info} name="fieldType" label="Type" type="select" required options={[
                        { id: 'text', name: 'Custom Text' },
                        { id: 'Signature', name: 'Signature' }
                    ]} />
                </Modal.Body>
                <Modal.Footer>
                    <button type="submit" className="btn btn-primary"><L>Insert</L></button>
                </Modal.Footer>
            </form>
        </Modal>
    }
}